import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import "./qualification.css";

const Qualification = () => {
  const [toggleState, setToggleState] = useState(1);

  const tabsRef = useRef(null);
  const tabRefs = useRef([]);
  const [indicatorStyle, setIndicatorStyle] = useState({ left: 0, width: 0 });

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const updateIndicator = () => {
    const container = tabsRef.current;
    const activeTab = tabRefs.current[toggleState - 1];
    if (!container || !activeTab) return;

    const containerRect = container.getBoundingClientRect();
    const activeRect = activeTab.getBoundingClientRect();

    // Handles horizontal scrolling tabs on small screens
    const left = activeRect.left - containerRect.left + container.scrollLeft;
    const width = activeRect.width;

    setIndicatorStyle({ left, width });
  };

  useLayoutEffect(() => {
    updateIndicator();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toggleState]);

  useEffect(() => {
    const onResize = () => updateIndicator();
    window.addEventListener("resize", onResize);

    const container = tabsRef.current;
    const onScroll = () => updateIndicator();
    if (container) container.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      window.removeEventListener("resize", onResize);
      if (container) container.removeEventListener("scroll", onScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="qualification section">
      <h2 className="section__title">Qualifications</h2>
      <span className="section__subtitle">Journey</span>

      <div className="qualification__container container">
        <div className="qualification__tabs-wrap">
          <div className="qualification__tabs" ref={tabsRef}>
            <button
              ref={(el) => (tabRefs.current[0] = el)}
              type="button"
              className={
                toggleState === 1
                  ? "qualification__button qualification__active button--flex"
                  : "qualification__button button--flex"
              }
              onClick={() => toggleTab(1)}
            >
              <i className="uil uil-graduation-cap qualification__icon"></i>
              Education
            </button>

            <button
              ref={(el) => (tabRefs.current[1] = el)}
              type="button"
              className={
                toggleState === 2
                  ? "qualification__button qualification__active button--flex"
                  : "qualification__button button--flex"
              }
              onClick={() => toggleTab(2)}
            >
              <i className="uil uil-briefcase-alt qualification__icon"></i>
              Experience
            </button>

            <button
              ref={(el) => (tabRefs.current[2] = el)}
              type="button"
              className={
                toggleState === 3
                  ? "qualification__button qualification__active button--flex"
                  : "qualification__button button--flex"
              }
              onClick={() => toggleTab(3)}
            >
              <i className="uil uil-award qualification__icon"></i>
              Certifications
            </button>

            <span
              className="qualification__indicator"
              style={{
                transform: `translateX(${indicatorStyle.left}px)`,
                width: `${indicatorStyle.width}px`,
              }}
            />
          </div>
        </div>

        <div className="qualification__sections">
          {/* Education */}
          <div
            className={
              toggleState === 1
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            <div className="qualification__content-inner">
              <div className="qualification__timeline">
                <div className="qualification__item">
                  <div className="qualification__left">
                    <h3>University of Malawi</h3>
                    <span>2017 - 2022</span>
                  </div>

                  <div className="qualification__center">
                    <span className="qualification__dot"></span>
                    <span className="qualification__vertical"></span>
                  </div>

                  <div className="qualification__right">
                    <h4>Bachelor's Degree in Education Computer Science</h4>
                    <p>
                      Understanding Core Computer Science concepts including programming languages, data structures and algorithms, and theories of computation.
                    </p>
                  </div>
                </div>

                <div className="qualification__item">
                  <div className="qualification__left">
                    <h3>National College of Information Technology</h3>
                    <span>2016 - 2017</span>
                  </div>

                  <div className="qualification__center">
                    <span className="qualification__dot"></span>
                  </div>

                  <div className="qualification__right">
                    <h4>L4 Diploma in Computing</h4>
                    <p>
                      Gained foundational knowledge in computing, covering areas such as programming, networking, databases, and web development.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Experience */}
          <div
            className={
              toggleState === 2
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            <div className="qualification__content-inner">
              <div className="experience__list">
                <div className="experience__item">
                  <div className="experience__header">
                    <div className="experience__text">
                      <h3>Global Health Informatics Institute - Applications Developer</h3>
                      <span>February 2024 - Current</span>
                    </div>
                    <span className="experience__plus">+</span>
                  </div>
                </div>

                <div className="experience__item">
                  <div className="experience__header">
                    <div className="experience__text">
                      <h3>Clive - Software Developer</h3>
                      <span>January 2023 - September 2023</span>
                    </div>
                    <span className="experience__plus">+</span>
                  </div>
                </div>

                <div className="experience__item">
                  <div className="experience__header">
                    <div className="experience__text">
                      <h3>Stella Maris Secondary School - Student Teacher</h3>
                      <span>September 2023 - December 2023</span>
                    </div>
                    <span className="experience__plus">+</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Certifications */}
          <div
            className={
              toggleState === 3
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            <div className="qualification__content-inner">
              <div className="certification__list">
                <div className="certification__item">
                  <h3>AWS Certified Solutions Architect - Associate</h3>
                  <span>Amazon Web Services · 2026</span>
                </div>
                <div className="certification__item">
                  <h3>AWS Certified Developer - Associate</h3>
                  <span>Amazon Web Services · 2025</span>
                </div>

                {/* <div className="certification__item">
                  <h3>Google Data Analytics Professional Certificate</h3>
                  <span>Google · 2025</span>
                </div> */}

                <div className="certification__item">
                  <h3>Foundational C#</h3>
                  <span>Microsoft · 2025</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* end sections */}
      </div>
    </section>
  );
};

export default Qualification;
